import { UrlObject } from "node:url";
import React from "react";

interface Props {
  title: string;
  to: UrlObject | string;
}

const Info: React.FC<Props> = ({ children }) => {
  return <div>{children}</div>;
};

export default Info;
